export interface CustomerOrganizationPollResponse {
  data: {
    organization: any;
    members: any;
    products: any;
    payments: any;
    paymentMethods: any;
    discounts: any;
    objects: any;
    etag: string;
  };
  id: number;
  done: boolean;
}

export interface CustomerOrganizationPollErrorResponse {
  text: string;
}

export enum CustomerOrganizationPollRequestType {
  Signin = 1,
  TokenRefresh = 2,
  ForcePoll = 3,
  Signout = 4,
}

export enum CustomerOrganizationPollResponseType {
  Poll = 1,
  TokenRefresh = 2,
  Error = 3,
  ConnectionOk = 4,
  ConnectionError = 5,
}
